<div class="datatable-list-with-actions" [class.horizontalList]="horizontalList()">
  @for (element of showMore() ? settings()?.list : settings()?.list?.slice(0, 1); track element) {
    <div class="datatable-list-with-actions__item">
      <div
        class="datatable-list-with-actions__chip"
        [matTooltip]="
          settings()?.toTooltipTranslator ? settings().toTooltipTranslator(element) : ''
        "
        (click)="click($event, element)"
      >
        {{ settings()?.toStringTranslator(element) }}
        @if (!readonly() && settings()?.showEditButton) {
          <mat-icon (click)="editButtonClicked($event, element)">edit </mat-icon>
        }
        @if (!readonly() && settings()?.showDeleteButton) {
          <mat-icon class="delete-icon" (click)="deleteButtonClicked($event, element)"
            >cancel
          </mat-icon>
        }
      </div>
      @if (
        (!showMore() && settings()?.list?.length > 1) ||
        (showMore() &&
          settings()?.list?.length > 1 &&
          element === settings()?.list?.[settings()?.list?.length - 1])
      ) {
        <div
          class="datatable-list-with-actions__chip"
          (click)="onToggleShowMore($event)"
          [matTooltip]="!showMore() ? 'show more' : 'show less'"
        >
          @if (showMore()) {
            <mat-icon>arrow_left</mat-icon>
          } @else {
            + {{ settings()?.list?.length - 1 }}
          }
        </div>
      }

      @if (
        !readonly() &&
        settings()?.showAddButton &&
        compactMode() &&
        (element === settings()?.list?.[settings()?.list?.length - 1] || !showMore())
      ) {
        <button
          class="compact-mode-add-button"
          mat-icon-button
          (click)="addButtonClicked($event)"
          color="accent"
          matTooltip="add"
        >
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
  }
  @if (
    !readonly() && settings()?.showAddButton && (!compactMode() || !(settings()?.list?.length > 0))
  ) {
    <button
      mat-icon-button
      (click)="addButtonClicked($event)"
      color="accent"
      matTooltip="add"
      [class.compact-mode-add-button]="compactMode()"
    >
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
